import styled from 'styled-components';

export const StyledStarButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: ${({ $active, theme }) =>
    $active ? (theme.isDark ? theme.headerAccent : theme.success) : theme.textFaint};
  flex-shrink: 0;
  border-radius: 50%;
  transition: color 150ms ease, background 150ms ease;
  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.isDark ? theme.headerAccent : theme.success};
    background: ${({ theme }) => theme.hover};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.headerAccent};
    outline-offset: 2px;
  }
  &:disabled {
    cursor: default;
    opacity: 0.55;
  }
`;
